import { render, staticRenderFns } from "./MainContent.vue?vue&type=template&id=3bf2bfba&"
import script from "./MainContent.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MainContent.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bf2bfba')) {
      api.createRecord('3bf2bfba', component.options)
    } else {
      api.reload('3bf2bfba', component.options)
    }
    module.hot.accept("./MainContent.vue?vue&type=template&id=3bf2bfba&", function () {
      api.rerender('3bf2bfba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/document/index/components/MainContent/MainContent.vue"
export default component.exports